<div class="custom-dialog-background" [class.force-width]="forceWidth()">
  <div
    class="custom-dialog"
    [style.--dialog-width]="width()"
    [class.no-padding]="noPadding()"
    [class.force-width]="forceWidth()"
  >
    @if (!hideCloseButton()) {
      <div class="custom-dialog-close-button" (click)="close()">
        <app-svg-icon [icon]="'assets/images/icon-close.svg'" [blank]="true" />
      </div>
    }

    @if (data) {
      @if (data.title) {
        <h2 class="custom-dialog-dyn-heading">{{ data.title }}</h2>
      }
      @if (data.subtitle) {
        <p class="custom-dialog-dyn-subtitle">{{ data.subtitle }}</p>
      }

      @if (showSeperator()) {
        <hr class="seperator" />
      }
      <div class="custom-dialog-content">
        <ng-container *ngComponentOutlet="data.component"></ng-container>
      </div>
    } @else {
      <h5
        #titleEl
        class="custom-dialog-title"
        [class.custom-dialog-title--empty]="titleEl.children.length === 0"
      >
        <ng-content select="[title]"></ng-content>
      </h5>
      @if (showSeperator()) {
        <hr class="seperator" />
      }
      <div class="custom-dialog-content">
        <ng-content select="[content]"></ng-content>
      </div>
      <div class="custom-dialog-buttons">
        <ng-content select="[buttons]"></ng-content>
      </div>
    }
  </div>
</div>
